import type { ICRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import {
  ClickEventComponentNames,
  CustomEventNames,
  EventTypes,
} from '@fhs-legacy/frontend/src/state/crm-events/constants';

export const logGiftCardsPageView = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.PAGE_VIEW,
    type: EventTypes.Other,
    attributes: {
      pathname: '/account/gift-cards',
      path: '/account/gift-cards',
      text: 'Gift Cards Page View',
    },
  });
};

export const logAddGiftCardPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Add Gift Card',
      payment_version: 'fresh',
    },
  });
};

export const logCheckBalancePress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Check Balance',
      payment_version: 'fresh',
    },
  });
};

export const logTransactionHistoryPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Transaction History',
      payment_version: 'fresh',
    },
  });
};

export const logViewDigitalGiftCardPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'View Digital Gift Card',
      payment_version: 'fresh',
    },
  });
};

export const logGiftCardContinuePress = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance'
) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue',
      flow,
      payment_version: 'fresh',
    },
  });
};

export const logGiftCardApiResponse = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance',
  result: 'success' | 'failure',
  errorMessage?: string
) => {
  logRBIEvent({
    name: CustomEventNames.ACTION_SHEET_SUBMISSION,
    type: EventTypes.Other,
    attributes: {
      flow,
      result,
      ...(errorMessage ? { errorMessage } : {}),
      payment_version: 'fresh',
    },
  });
};
